<app-list-view-toolbar [columns]="columns" [preferencesKey]="preferencesKey" (columnsChanged)="ColumnChanged($event)"></app-list-view-toolbar>
<div class="d-md-block table-container">
  <div class="scroll-x scroll-x-shadows">
    <table class="table table-hover">
      <thead>
        <tr>
          <th class="counter">{{ 'COMMON.COUNT' | translate }}</th>
          @for (column of selectedColumns; track column) {
            @if (column.helpText) {
              <th
                class="column-header"
                appTooltip="{{ column.helpText | translate }}"
                tooltipPosition="below"
                [dh-list-view-header]="column.id"
                [canSort]="column.canSort"
                (stateChange)="onStateChange($event)"
                >
                {{ column.caption | translate }}
              </th>
            }
            @if (!column.helpText) {
              <th
                class="column-header"
                [dh-list-view-header]="column.id"
                [canSort]="column.canSort"
                (stateChange)="onStateChange($event)"
                >
                {{ column.caption | translate }}
              </th>
            }
          }
          @if (hasContextMenu) {
            <th></th>
          }
          <th></th>
        </tr>
      </thead>
      <tbody class="table-striped">
        @for (row of rows | slice: from : to; track trackByFunction(i, row); let i = $index) {
          <tr appListViewItem [class.highlight]="row.highlight" [ngClass]="{ 'error-in-row': isErrorInRow(row) }">
            @if (hasMultiSelect) {
              <td>
                <div class="rowcount">
                  <mat-checkbox [(ngModel)]="row.selected" (click)="$event.stopPropagation()" (change)="checkSelectedItems()">{{
                    getRowNumber(i)
                  }}</mat-checkbox>
                </div>
              </td>
            }
            @if (!hasMultiSelect) {
              <td (click)="onRowClicked(row, $event)">
                <span>{{ getRowNumber(i) }}</span>
              </td>
            }
            @for (column of selectedColumns; track column) {
              <td (click)="onRowClicked(row, $event)">
                <dh-custom-view
                  [viewType]="column.viewType"
                  [value]="row.getValue(column)"
                  [helpText]="row.getHelpText(column)"
                ></dh-custom-view>
              </td>
            }
            @if (hasContextMenu) {
              <td>
                <app-context-menu-inline [context]="row.dataSource" [menuDefinition]="contextMenuDefinition"></app-context-menu-inline>
              </td>
            }
            <td (click)="onRowClicked(row, $event)">
              <div class="expand-icons">
                <i [class]="$any(row).expanded ? 'expanded' : 'not-expanded'"></i>
              </div>
            </td>
          </tr>
          <tr class="accordion-details-row">
            <td [attr.colspan]="hasContextMenu ? columns.length + 3 : columns.length + 2" class="component-container">
              <div class="accordion-details-wrapper" [@expandCollapse]="$any(row).expanded ? 'expanded' : 'collapsed'">
                @if ($any(row).expanded && shouldComponentRerender) {
                  <ng-container *ngComponentOutlet="accordionComponent; inputs: generateInputData(row)"></ng-container>
                }
              </div>
            </td>
          </tr>
        }
        <tr class="list-summary">
          <td class="counter">
            @if (hasMultiSelect) {
              <span>{{ selectedItemsCount ? selectedItemsCount.toString() + '/' : '' }}{{ totalCount }}</span>
            }
            @if (!hasMultiSelect) {
              <span>{{ totalCount }}</span>
            }
          </td>
          @for (column of selectedColumns; track column) {
            <td>
              @if (column.sum) {
                @for (summary of sumValues(column); track $index) {
                  <div>{{ summary.displayValue }}</div>
                }
              }
            </td>
          }
          @if (hasContextMenu) {
            <td></td>
          }
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
  <app-paging [totalCount]="totalCount" (onPageChange)="pagingChanged($event)"></app-paging>
</div>
